<template>
    <input
        type="checkbox"
        ref="element"
        v-bind="{
            ...( defaultValue === true && {
                checked: true
            }),
            ...( !allowFilling && { disabled: true })
        }"
        v-on="{
            ...( allowFilling && {
                change: action
            })
        }"
    >
</template>

<script>
// packages
import { ref, onMounted } from '@vue/composition-api';

// hooks
import { reset } from '@/hooks/use-input-listeners';

export default {
    props: {
        reset: Boolean,
        defaultValue: Boolean,
        allowFilling: {
            type: Boolean,
            default: true
        }
    },
    setup ( props, { emit }) {
        const element = ref( null );

        onMounted( () => {
            // listener para quando for necessário
            // proceder a um reset a input.
            reset({ props, object: element.value, key: 'value' });
        });

        // emissão do valor da input para o
        // componente pai.
        const action = $event => {
            const input = $event.target;
            emit( 'input', input.checked );
        };

        return { element, action };
    }
};
</script>